/* Brand landing kit — extras on top of libernovo-landing.js (which already runs
   .ln-anim, [data-ln-swiper], [data-ln-tabs] and video[data-ln-video]).
     [data-bl-hero]            label pager + filling progress synced to the Swiper
     [data-bl-play]            opens the shared video dialog
                               data-bl-yt="<YouTube id>" | data-bl-mp4="<url>" (+ data-bl-tall)
     [data-bl-step="-1|1"]     steps the nearest [data-ln-tabs] (compare arrows)
     [data-bl-ft]              feature tabs: active clip plays (in turn when data-bl-ft-auto),
                               progress line under the active tab
*/
(function () {
  'use strict';
  var D = document;
  var W = window;

  /* ---------- hero pager ---------- */
  function heroInit(root) {
    if (root.blReady) return;
    var swEl = root.querySelector('[data-ln-swiper]');
    var sw = swEl && swEl.lnSwiper;
    if (!sw) {
      /* Swiper is created by libernovo-landing.js once the bundle has loaded */
      root.blTries = (root.blTries || 0) + 1;
      if (root.blTries < 60) W.setTimeout(function () { heroInit(root); }, 120);
      return;
    }
    root.blReady = true;
    var pgs = [].slice.call(root.querySelectorAll('[data-bl-pg]'));

    function mark() {
      var i = typeof sw.realIndex === 'number' ? sw.realIndex : sw.activeIndex;
      pgs.forEach(function (b, j) {
        var on = j === i;
        /* re-adding the class restarts the CSS fill animation */
        b.classList.remove('is-active');
        if (on) { void b.offsetWidth; b.classList.add('is-active'); }
        b.setAttribute('aria-current', on ? 'true' : 'false');
      });
      /* Swiper 11 loop mode re-orders slides in the DOM: read the live one */
      var s = sw.slides && sw.slides[sw.activeIndex];
      var light = !!(s && s.classList.contains('bl-hero__slide--dark'));
      root.classList.toggle('is-dark', light);
      if (root.classList.contains('bl-hero--overlay')) D.body.classList.toggle('bl-hero-light', light);
    }
    pgs.forEach(function (b, j) {
      b.addEventListener('click', function () {
        if (sw.params.loop) sw.slideToLoop(j); else sw.slideTo(j);
        if (sw.autoplay && sw.autoplay.running) { sw.autoplay.stop(); sw.autoplay.start(); }
      });
    });
    sw.on('slideChange', mark);
    sw.on('autoplayPause', function () { root.classList.add('is-paused'); });
    sw.on('autoplayResume', function () { root.classList.remove('is-paused'); });
    mark();

    /* later slides are loading="lazy" and would only start downloading as they
       slide in (a black frame on the first pass): warm them once the page is idle */
    function warm() {
      [].slice.call(root.querySelectorAll('img[loading="lazy"]')).forEach(function (im) { im.loading = 'eager'; });
    }
    function idle() { if (W.requestIdleCallback) W.requestIdleCallback(warm, { timeout: 2000 }); else W.setTimeout(warm, 200); }
    if (D.readyState === 'complete') idle(); else W.addEventListener('load', idle, { once: true });
  }

  /* ---------- video dialog ---------- */
  var dlg = null;
  function dialog() {
    if (dlg) return dlg;
    dlg = D.createElement('dialog');
    dlg.className = 'bl-dialog';
    dlg.setAttribute('aria-label', 'Video');
    dlg.innerHTML = '<button type="button" class="bl-dialog__close" aria-label="Close video">&times;</button><div class="bl-dialog__frame"></div>';
    D.body.appendChild(dlg);
    var frame = dlg.querySelector('.bl-dialog__frame');
    /* 'close' fires async: skip the wipe if the dialog was reopened meanwhile */
    function clear() { if (!dlg.open) frame.innerHTML = ''; }
    dlg.querySelector('.bl-dialog__close').addEventListener('click', function () { dlg.close(); });
    dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
    dlg.addEventListener('close', clear);
    return dlg;
  }
  function openVideo(btn) {
    var d = dialog();
    var frame = d.querySelector('.bl-dialog__frame');
    var yt = btn.getAttribute('data-bl-yt');
    var mp4 = btn.getAttribute('data-bl-mp4');
    frame.classList.toggle('bl-dialog__frame--tall', btn.hasAttribute('data-bl-tall'));
    if (yt) {
      frame.innerHTML = '<iframe src="https://www.youtube-nocookie.com/embed/' + encodeURIComponent(yt) +
        '?autoplay=1&rel=0&playsinline=1" title="' + (btn.getAttribute('aria-label') || 'Video') +
        '" allow="autoplay; encrypted-media; picture-in-picture; fullscreen" allowfullscreen></iframe>';
    } else if (mp4) {
      var v = D.createElement('video');
      v.src = mp4; v.controls = true; v.autoplay = true; v.playsInline = true;
      frame.innerHTML = ''; frame.appendChild(v);
    } else { return; }
    if (typeof d.showModal === 'function') d.showModal(); else d.setAttribute('open', '');
  }

  /* ---------- tab stepping (compare arrows) ---------- */
  function step(btn) {
    var root = btn.closest('[data-ln-tabs]');
    if (!root || !root.lnTabs) return;
    var t = root.lnTabs, keys = t.keys, i = keys.indexOf(t.current());
    var n = parseInt(btn.getAttribute('data-bl-step'), 10) || 1;
    t.stop();
    t.set(keys[(i + n + keys.length) % keys.length], { source: 'click' });
  }

  D.addEventListener('click', function (e) {
    var play = e.target.closest('[data-bl-play]');
    if (play) { e.preventDefault(); openVideo(play); return; }
    var st = e.target.closest('[data-bl-step]');
    if (st) { e.preventDefault(); step(st); }
  });

  /* ---------- compare clips: only the active pair loads and plays ---------- */
  function cmpInit(root) {
    if (root.blReady) return;
    root.blReady = true;
    var inView = false;
    function sync() {
      [].slice.call(root.querySelectorAll('[data-ln-panel]')).forEach(function (panel) {
        var on = inView && panel.classList.contains('is-active');
        [].slice.call(panel.querySelectorAll('video[data-bl-cmp-video]')).forEach(function (v) {
          if (on) {
            if (!v.getAttribute('src')) { v.src = v.getAttribute('data-src'); }
            var p = v.play(); if (p && p.catch) p.catch(function () {});
          } else if (!v.paused) { v.pause(); }
        });
      });
    }
    root.addEventListener('ln:tab', function () { W.setTimeout(sync, 0); });
    if ('IntersectionObserver' in W) {
      new IntersectionObserver(function (es) { inView = es[0].isIntersecting; sync(); }, { threshold: 0.2 }).observe(root);
    } else { inView = true; sync(); }
  }

  /* ---------- feature tabs: clips play in turn, a picked tab loops ---------- */
  function ftInit(root) {
    if (root.blReady) return;
    var tabs = root.lnTabs;
    if (!tabs) {
      /* the tabs engine (libernovo-landing.js) may not have run yet */
      root.blTries = (root.blTries || 0) + 1;
      if (root.blTries < 60) W.setTimeout(function () { ftInit(root); }, 120);
      return;
    }
    root.blReady = true;
    var reduced = !!(W.matchMedia && W.matchMedia('(prefers-reduced-motion: reduce)').matches);
    var auto = root.hasAttribute('data-bl-ft-auto') && !reduced;
    var mobile = W.matchMedia ? W.matchMedia('(max-width: 749px)') : { matches: false };
    var picked = false, inView = false, timer = null;
    var bar = root.querySelector('.bl-ft__tabs');
    var vids = [].slice.call(root.querySelectorAll('video[data-bl-ft-video]'));

    function fill(key, p) {
      var b = root.querySelector('[data-ln-tab="' + key + '"] .bl-ft__bar');
      if (b) b.style.transform = 'scaleX(' + Math.max(0, Math.min(1, p)) + ')';
    }
    function load(v) {
      if (v.getAttribute('src')) return;
      var src = (mobile.matches && v.getAttribute('data-src-mobile')) || v.getAttribute('data-src-desktop');
      if (src) v.src = src;
    }
    function run() {
      W.clearTimeout(timer);
      vids.forEach(function (v) { if (!v.paused) v.pause(); });
      var key = tabs.current();
      [].slice.call(root.querySelectorAll('.bl-ft__bar')).forEach(function (b) { b.style.transform = 'scaleX(0)'; });
      var btn = root.querySelector('[data-ln-tab="' + key + '"]');
      /* keep the active tab visible in the phone's scrolling tab row (no page jump) */
      if (btn && bar && bar.scrollWidth > bar.clientWidth) {
        bar.scrollTo({ left: btn.offsetLeft - (bar.clientWidth - btn.offsetWidth) / 2, behavior: 'smooth' });
      }
      if (!inView) return;
      var panel = root.querySelector('.bl-ft__panel[data-ln-panel="' + key + '"]');
      var v = panel && panel.querySelector('video[data-bl-ft-video]');
      if (v) {
        if (reduced && !picked) return;
        load(v);
        v.loop = picked || !auto;
        try { v.currentTime = 0; } catch (e) {}
        var pr = v.play(); if (pr && pr.catch) pr.catch(function () {});
      } else if (auto && !picked) {
        /* image feature: hold it for a few seconds, then move on */
        var t0 = Date.now(), hold = 6000;
        (function tick() {
          var p = (Date.now() - t0) / hold;
          fill(key, p);
          if (p >= 1) { tabs.next(); return; }
          timer = W.setTimeout(tick, 100);
        })();
      }
    }
    vids.forEach(function (v) {
      var key = v.closest('[data-ln-panel]').getAttribute('data-ln-panel');
      v.addEventListener('timeupdate', function () { if (v.duration) fill(key, v.currentTime / v.duration); });
      v.addEventListener('ended', function () { if (auto && !picked && key === tabs.current()) tabs.next(); });
    });
    root.addEventListener('ln:tab', function (e) {
      if (e.detail && e.detail.source === 'click') picked = true;
      run();
    });
    if ('IntersectionObserver' in W) {
      new IntersectionObserver(function (es) {
        var was = inView; inView = es[0].isIntersecting;
        if (inView !== was) run();
      }, { threshold: 0.35 }).observe(root);
    } else { inView = true; run(); }
  }

  function init() {
    [].slice.call(D.querySelectorAll('[data-bl-hero]')).forEach(heroInit);
    [].slice.call(D.querySelectorAll('.bl-cmp')).forEach(cmpInit);
    [].slice.call(D.querySelectorAll('[data-bl-ft]')).forEach(ftInit);
  }
  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', init); else init();
  D.addEventListener('shopify:section:load', function () { W.setTimeout(init, 50); });
})();
